export default __webpack_public_path__ + "static/media/create-icon.05047cc7.svg";